import React, { lazy, useEffect, useState } from 'react';
// import Cookies from 'js-cookie';
// import Patient from '../../Patient/Patient';
// // import Claims from '../../Billing/Claims/Claims';
// import Payments from '../../Billing/Payments/Payments';
// import Report from '../../Reports/Report';
import { useDispatch, useSelector } from 'react-redux';
// import { TabActionPatient } from "../../../actions/PatientActions";
// import { TabActionReports} from '../../../actions/ReportActions/ReportActions';
// import { TabActionClaims } from '../../../actions/BillingActions';
// import { TabActionPayments } from '../../../actions/BillingActions';
import { MainTabContentActiveTab , MainTabContentTabList} from '../../../actions/SidebarAction';
import {useOpenSideBar} from './HandleOpen';
import useIndexDatabase from '../../../customhooks/useIndexDatabase';

// const Claims = lazy(()=> import("../../Billing/Claims/Claims"))

const ContentReceiver = ({data,setOpenTab}) => {
  //////////////////////////////////// database name, version number, store name
  const { db, get, remove } = useIndexDatabase('SHCTDatabase', 1, 'ChildWindow');
  let dispatch = useDispatch()
  let state = useSelector(state => state?.SidebarList)
  const handleActive_SubTab = ( key, name, component, right) => {
          let arr = state
          let dynamicTabs = [...arr]
          const newTabObject = {
              key: key,
              name: name,
              component: component,
              right: right,
              time: new Date(),
          }
      const isTabExist = dynamicTabs.filter((tab) => {
          return tab.name === name
      })
      if (!(isTabExist && isTabExist.length > 0)) {
          dynamicTabs = [...dynamicTabs, newTabObject]
          dispatch(MainTabContentTabList(dynamicTabs));
      }
      dispatch(MainTabContentActiveTab(key))
      setOpenTab && setOpenTab('')
  }
  const handleOpen = useOpenSideBar(handleActive_SubTab);
  useEffect(() => {
    const fetchData = async () => {
        const cookieValue = await get('browserNewTabContent');
        // Process the data
        const content = cookieValue?.value ? JSON.parse(cookieValue?.value) : null;

        console.log(data, content, 'handleOpen');
        
        data ? handleOpen(data) : content && handleOpen(content);
        remove('browserNewTabContent')
        // Cookies.remove('browserNewTabContent');
      }
    if (db) {
      fetchData(); 
    };
  }, [db]);

  return null;
};
export default ContentReceiver;
